module.exports = __webpack_public_path__ + "img/logo-house-medium-5.2f51790a.svg";